import AccountsReceivableNumberConfig from './AccountsReceivableNumberConfig';
import InvoiceNumberConfig from './InvoiceNumberConfig';
import MandateReferenceNumberConfig from './MandateReferenceNumberConfig';
import MemberSettings from './MemberSettings';

export default class NumberRangeSettings {
    static fromData(data) {
        if (!data) {
            return;
        }

        let numberRangeSettings = new NumberRangeSettings();
        numberRangeSettings.invoiceNumberConfig = InvoiceNumberConfig.fromData(data.invoiceNumberConfig);
        numberRangeSettings.memberSettings = MemberSettings.fromData(data.memberSettings);
        numberRangeSettings.accountsReceivableNumberConfig = AccountsReceivableNumberConfig.fromData(data.accountsReceivableNumberConfig);
        numberRangeSettings.mandateReferenceNumberConfig = MandateReferenceNumberConfig.fromData(data.mandateReferenceNumberConfig);
        numberRangeSettings.biggestInvoiceNumberLength = data.biggestInvoiceNumberLength;

        return numberRangeSettings;
    }
}
